import React, { useEffect, useContext, useState } from 'react';
import { Icon, Button, Form, Input, Message, Modal, Grid, Image, Header, Checkbox, Divider } from 'semantic-ui-react'
import useAuth from '../../../hooks/useAuth';
import { useHistory } from "react-router-dom";
import AuthContext from '../../../context/authContext';
import { ConnectWS } from '../../../ConnectWS'
import { useToasts } from 'react-toast-notifications';
import { useCookies } from 'react-cookie';
import { SCezarencrypt, SCezardecrypt } from "../../../myfunctions"
import LogoTeamLigaGenerator from '../../../assets/tglogov6_small.png';
import ShowInfoTestPlayer from '../../../tools/ShowInfoTestPlayer';
import SearchLic from '../../../tools/SearchLic';

function Login() {
    const { addToast } = useToasts();
    const [auth, setAuth] = useAuth();// eslint-disable-line no-unused-vars
    const authContext = useContext(AuthContext);
    const [openLogowanie, setOpenLogowanie] = useState(false)
    const [showBtnSendMail, setshowBtnSendMail] = useState(false)
    const [loginStatus, setloginStatus] = useState(null);
    const [loading, setloading] = useState(false);
    const [CheckboxS, setCheckboxS] = useState(false);

    const [cookies, setCookie, removeCookie] = useCookies(['UserData']);
    let history = useHistory();
    const [form, setForm] = useState({
        password: '',
        email: '',
    });

    useEffect(() => {
        if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
            console.log("View: Login")
        }

        if (authContext.modalInfo && authContext.modalInfo.nameModal === "logowanie") {
            if (cookies.UserData) {
                setForm({ ...form, password: SCezardecrypt(cookies.UserData.password), email: cookies.UserData.email })
                setCheckboxS(true)
            }
            setloginStatus(null)
            setOpenLogowanie(true)

        }
        return () => { }; // use effect cleanup to set flag false, if unmounted
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    function submitLogin(e,p){
       
        
        setloginStatus(null)
        setloading(true)
        setshowBtnSendMail(false)
        let email = e ? e :  form.email
        let password = p ? p : form.password


        if (CheckboxS) {
            let expiresdate = new Date();
            let today = new Date();
            expiresdate.setDate(today.getDate() + 30);
            setCookie('UserData', { email: email, password: SCezarencrypt(password) }, { path: '/', expires: expiresdate });
        }

        ConnectWS("/login", null, { email: email, password: password }, function (response, logout) {

            if (logout === 1) {
                setloginStatus({ value: response.error, error: true, success: false })
                if (response.status === 4) {
                    setshowBtnSendMail(true)
                }
            } else if (response && response.status && Number(response.status) === 200) {
                let userInfo = { fullName: response.data.fullname, imgProfile: response.data.imgProfile, userId: response.data.userId, email: response.data.email, admin: response.data.admin, s: password, subscription_info: response.data.subscription_info }
                authContext.changeUser(userInfo);
                authContext.changeToken(response.data.token);
                authContext.changeView({ myView: "MyAccount" });
                setAuth(true, response.data.token, JSON.stringify(userInfo));
                addToast('Logowanie prawidłowe', { appearance: 'success' });
                if (window.location.pathname.includes("resetPassword")) {
                    setTimeout(function () { history.push("/") }, 1000);
                }

                closeOpenModal()
            } else {
                setloginStatus({ value: response.error, error: true, success: false })
                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }
            setloading(false)


        });


    }

    const remindPass = e => {
        e.preventDefault();
        setloginStatus(null)
        setshowBtnSendMail(false)
        console.log(form)
        if (typeof form.email === 'undefined' || form.email.length < 3 || form.email.indexOf("@") < 1) {
            setloginStatus({ value: "Wpisz prawidłowy adres e-mail", error: true, success: false })
            return
        }
        let email = form.email
        ConnectWS("login/resetPassword", null, { email: email, generatorTL: 1 }, function (response, logout) {

            if (logout === 1) {

            } else if (response && response.status && Number(response.status) === 200) {
                setloginStatus({ value: response.data.message, error: false, success: true })

            } else {
                setloginStatus({ value: response, error: true, success: false })

                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }
            setloading(false)


        });
    }

    const resendActivationEmail = e => {
        e.preventDefault();
        setloginStatus(null)
        setshowBtnSendMail(false)
        let email = form.email
        ConnectWS("/login/resendActivationEmail", null, { email: email, generatorTL: 1 }, function (response, logout) {

            if (logout === 1) {

            } else if (response && response.status && Number(response.status) === 200) {
                setloginStatus({ value: response.data.message, error: false, success: true })

            } else {
                setloginStatus({ value: response, error: true, success: false })

                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }
            setloading(false)


        });

    }

    function closeOpenModal() {
        setOpenLogowanie(false)
        authContext.changeModalInfo(false)
    }

    function showRegistration() {
        setOpenLogowanie(false)
        authContext.changeModalInfo({ nameModal: "rejestracja" })

    }

    const onChangeCheckbox = (evt, data) => {

        if (data.checked) {

        }
        else {
            removeCookie('UserData')
        }
        setCheckboxS(data.checked)

    }

    function loginToDemo(){
        setForm({ ...form, email: "demo@turniej-generator.pl",password:"demogenerator" })
        setTimeout(() => {
            submitLogin("demo@turniej-generator.pl","demogenerator")
          }, 200);
       
    }

    return (
        <>
            <Modal
                dimmer='blurring'
                closeIcon
                centered={true}
                onClose={() => closeOpenModal()}
                onOpen={() => setOpenLogowanie(true)}
                open={openLogowanie}
                size={'large'}

            >
                <Modal.Header>
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={12} verticalAlign="middle">
                                <Header as='h2' textAlign='center'>
                                    <Icon name='user' color="red" />
                                    <Header.Content>Logowanie</Header.Content>
                                </Header>
                            </Grid.Column>
                            <Grid.Column width={4} textAlign="right" only='large screen'>
                                <Image floated='right' size='big' alt="logo" centered src={LogoTeamLigaGenerator} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content className='modalBGcolor' scrolling>
                    <Grid stackable>
                        <Grid.Row verticalAlign='middle'>
                            <Grid.Column width={6}>
                                <Form onSubmit={()=>submitLogin()} size='mini'>
                                    <Form.Field
                                        control={Input}
                                        required
                                        type="email"
                                        label='E-mail'
                                        placeholder='E-mail'
                                        value={form.email}
                                        onChange={(e, data) => setForm({ ...form, email: data.value })}
                                    />
                                    <Form.Field
                                        control={Input}
                                        type="password"
                                        required
                                        label='Hasło'
                                        placeholder='Hasło'
                                        value={form.password}
                                        onChange={(e, data) => setForm({ ...form, password: data.value })}
                                    />
                                    <Checkbox label='Pamiętaj moje dane logowania' checked={CheckboxS ? true : false} style={{ 'paddingBottom': '10px' }} onClick={(evt, data) => onChangeCheckbox(evt, data)} />


                                    <Button.Group fluid size='mini'>
                                        <Button style={{ marginTop: 5, marginBottom: 5 }} color='google plus' disabled={loading ? true : false} loading={loading ? true : false} >ZALOGUJ</Button>

                                        <Button.Or text='lub' style={{ marginTop: 5 }} />
                                        <Button type='button' style={{ marginTop: 5, marginBottom: 5 }} color='blue' onClick={() => loginToDemo()} disabled={loading ? true : false} loading={loading ? true : false} >SKORZYSTAJ Z KONTA DEMO</Button>

                                    </Button.Group> </Form>
                                
                                <a href="!#" className="linktl" onClick={(e) => remindPass(e)}><Icon name="key" />Przypomnienie hasła</a>
                                
                                {loginStatus ? <Message
                                    error={loginStatus.error ? true : false}
                                    success={loginStatus.success ? true : false}
                                > {loginStatus.value}{showBtnSendMail ? <Button color='google plus' size='mini' style={{ marginLeft: 5 }} disabled={loading ? true : false} loading={loading ? true : false} onClick={(e) => resendActivationEmail(e)} >Wyślij ponownie maila</Button> : ''}</Message> : ''}

                                <Divider />
                                Nie masz konta? Zarejestruj się:
                                <Button style={{ marginTop: 2 }} size="mini" color='brown' fluid onClick={() => showRegistration()} >UTWÓRZ KONTO</Button>


                            </Grid.Column>
                            <Grid.Column width={10}>
                                <ShowInfoTestPlayer fullView={false} />
                                
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                    <Divider />
                    <SearchLic msize="small" closeOpenModal={closeOpenModal} />





                </Modal.Content>

            </Modal>

        </>
    )
}

export default Login;